// extracted by mini-css-extract-plugin
module.exports = {"image":"Congratulations_image__22zyr"};